function QuizDifficultLevel() {
  return <h2 className="select-quiz">Select the quiz difficult level</h2>;
}

export default QuizDifficultLevel;
